const caES = require('./ca-ES');

module.exports = {
  ...caES,
  momentFormat: 'DD-MM-YYYY',
};
